import React, { Component } from 'react';
import RegistrationForm from '../../components/RegistrationForm/RegistrationForm';

class RegistrationRoute extends Component {
  static defaultProps = {
    history: {
      push: () => {},
    },
  };

  handleRegistrationSuccess = () => {
    const { history } = this.props;
    history.push('/login');
  };

  render() {
    return (
      <section className='container-section'>
        <p>Practice learning a language with the spaced reptition revision technique.</p>
        <h2>Sign up</h2>
        <p>Fields with * are required!</p>
        <RegistrationForm onRegistrationSuccess={this.handleRegistrationSuccess} />
      </section>
    );
  }
}

export default RegistrationRoute;
